export const usePaginate = (data, pageSize, currentPage) => {
  let [pages, paginatedData] = [0, []];
  let start = currentPage * pageSize;
  let end = pageSize * (currentPage + 1);
  pages = Math.ceil(data?.length / pageSize);
  paginatedData = data.slice(start, end);
  return [paginatedData, pages];
};
